import { render } from "./CANDIDATE_VAL_NEW_CONSOLIDATED.vue?vue&type=template&id=37d74dde"
import script from "./CANDIDATE_VAL_NEW_CONSOLIDATED.vue?vue&type=script&lang=js"
export * from "./CANDIDATE_VAL_NEW_CONSOLIDATED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__